<template>
  <v-container>
    <v-container id="regular-tables-view" tag="section">
      <v-tabs v-model="stab" color="primary accent-4">
        <v-tab
          v-for="(school, sindex) in schools"
          :key="sindex"
          @click="_selectSchool(school)"
          >{{ school.name }}</v-tab
        >
      </v-tabs>
      <v-tabs-items v-model="stab">
        <v-tab-item v-for="(school, ssindex) in schools" :key="ssindex">
          <v-tabs v-model="departmentSelected" color="primary accent-4">
            <v-tab> Teachers</v-tab>
            <v-tab> Lessons</v-tab>
            <v-tab @click="_selectedSemester(school)">
              Semesters
              <span v-if="school.semesters != null">
                ({{ school.semesters.length }})</span
              ></v-tab
            >
          </v-tabs>
          <v-tabs-items v-model="departmentSelected">
            <v-tab-item>
              <employee-table
                :item="{ name: title, fbpath: collectionName }"
                :school="school"
              ></employee-table>
            </v-tab-item>
            <v-tab-item>
              <v-card
                v-for="(semester, semindex) in school.semesters"
                :key="semindex"
              >
                <section>
                  <lesson-standard-table
                    :item="{ name: 'Xичээлүүд', fbpath: 'lessons-standards' }"
                    :school="school"
                  ></lesson-standard-table>
                </section>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card
                v-for="(semester, semindex) in school.semesters"
                :key="semindex"
              >
                <semester-lessons
                  :schoolId="school.id"
                  :semesterPath="semester.ref.path"
                ></semester-lessons>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tab-item>
      </v-tabs-items>

      <div class="py-3" />
    </v-container>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { currentUser } from "../firebaseConfig";
import moment from "moment";

const fb = require("../firebaseConfig.js");
export default {
  data: () => ({
    schools: null,
    stab: null,
    departmentSelected: null,
    collectionName: "employees",
    title: "Багш, aжилтан",
    schoolSelected: null,
  }),
  components: {
    EmployeeTable: () => import("@/views/teacher/EmployeeTable"),
    LessonStandardTable: () => import("./infos/LessonStandardTable"),
    SemesterLessons: () => import("./infos/SemesterLessons"),
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  created() {
    this._setupp();
    this._read();
  },

  methods: {
    _selectSchool(school) {
      this.schoolSelected = school;
      if (!school.employees) {
        school.ref
          .collection(this.collectionName)
          .get()
          .then((querySnapshot) => {
            {
              if (!school.employees) {
                school.employees = [];
                querySnapshot.forEach((doc) => {
                  let employee = doc.data();
                  employee.id = doc.id;
                  employee.ref = doc.ref;
                  school.employees.push(employee);
                });
              }
            }
          });
      }
    },
    _selectedSemester(school) {
      console.log(school);
      if (!(school && school.semesters != null)) {
        school.ref
          .collection("semesters")
          .orderBy("name", "asc")
          .get()
          .then((querySnapshot) => {
            {
              school.semesters = [];
              querySnapshot.forEach((doc) => {
                console.log(doc.data());
                let semester = doc.data();
                semester.id = doc.id;
                semester.ref = doc.ref;

                school.semesters.push(semester);
                // if (this.semesters.length == 1) {
                //   this._selectSchool(this.semesters[0]);
                // }
              });
            }
          });
      }
    },
    _setupp() {
      console.log(this.userProfile);
    },
    _read() {
      fb.db
        .collection("schools")
        .orderBy("name", "asc")
        .get()
        .then((querySnapshot) => {
          {
            this.schools = [];
            querySnapshot.forEach((doc) => {
              let school = doc.data();
              school.id = doc.id;
              school.ref = doc.ref;

              if (school.ref.path === this.userProfile.school.path)
                this.schools.push(school);
              if (this.schools.length == 1) {
                this._selectSchool(this.schools[0]);
              }


            });
          }
        });

    },
  },
};
</script>
